export default __webpack_public_path__ + "static/media/roadmap.72074faf.jpg";